import request from '@/utils/request'

export function getActivityAll (data) {
  return request({
    url: 'activity/notcheck/all',
    method: 'post',
    data
  })
}

export function getActivityJoin () {
  return request({
    url: 'activity/join',
    method: 'get'
  })
}
